import { EElementType, ILandingElement } from '~/src/services/projects';
import { fonts } from '~/src/helpers/font';

export const BlockSliderNuka: ILandingElement = {
    title: 'BlockSliderNuka',
    type: EElementType.Block,
    label: 'Слайдер блоков Nuka',
    properties: {
        customStyles: '',
        addElement: EElementType.TabColumn,
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        backgroundColor: '',
        marginTop: '',
        marginBottom: '',
    },
    children: [
        {
            title: 'Header',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H3,
                    color: '#1A1A1A',
                    lineHeight: '1.3',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: ' ',
                customStyles: 'white-space: pre-wrap;',
            },
        },
    ],
};
